module.exports = __webpack_public_path__ + "media/images/angular_logo-67b518a4417768dc8060909f68b9f287.png";